// Preserve zero values and distinguish unavailable sources from zero denominators.
export function portfolioMetricRows (metrics, record = {}, loading = false, error = '') {
  return [
    { key: 'kwh', source: 'energy', label: '本期综合用电', unit: '万 kWh', divider: 10000 },
    { key: 'collection', source: 'bills', label: '水电费用实收率', unit: '%', divider: 1 },
    { key: 'onlineRate', source: 'devices', label: '设备在线率', unit: '%', divider: 1 }
  ].map(row => {
    const value = metrics[row.key]
    const source = record[row.source]
    let status = ''
    if (loading) status = '数据加载中'
    else if (error || (source && source.state === 'error')) status = '数据获取失败'
    else if (value == null || !Number.isFinite(value)) {
      if (!source) status = '暂未接入'
      else if (row.key === 'collection' && metrics.fees === 0) status = '本期暂无应收'
      else if (row.key === 'onlineRate' && metrics.devices === 0) status = '暂无接入设备'
      else status = '本期暂无数据'
    }
    return { ...row, value, status, retry: status === '数据获取失败' }
  })
}
